// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 133) return "js/datadogRecorder.js";
	if (chunkId === 50) return "js/datadogProfiler.js";
	// return url for filenames based on template
	return undefined;
};